import { Component, OnInit, AfterViewInit } from '@angular/core';
import { transition, style, animate, trigger } from '@angular/animations';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { NavService } from '../../../services/nav.service';
import { Router } from '@angular/router';

//Transition Effects On Collapse
const enterTransition = transition(':enter', [
  style({
    opacity: 0,
  }),
  animate(
    '0.5s ease-in',
    style({
      opacity: 1,
    })
  ),
]);

const leaveTrans = transition(':leave', [
  style({
    opacity: 1,
  }),
  animate(
    '0.5s ease-out',
    style({
      opacity: 0,
    })
  ),
]);

const fadeIn = trigger('fadeIn', [enterTransition]);

const fadeOut = trigger('fadeOut', [leaveTrans]);
@Component({
  selector: 'app-left-side-bar',
  templateUrl: './left-side-bar-updated.component.html',
  styleUrls: ['./left-side-bar.component.scss'],
  animations: [fadeIn, fadeOut],
})
export class LeftSideBarComponent implements OnInit, AfterViewInit {
  constructor(private router: Router, public navService: NavService, private authService: AuthenticationService) {}

  ngOnInit(): void {}
  ngAfterViewInit(): void {
    // Update ngScrollContent height
    if (typeof document !== undefined) {
      const ngScrollContent = document.querySelector('.ng-scroll-content');
      if (ngScrollContent) (ngScrollContent as HTMLDivElement).style.height = '100%';
    }
  }
  onClickOutSide(e: any) {
    this.navService.setSideNav(false);
  }
  toggleNav(e: Event, nav: any) {
    e.stopPropagation();
    e.preventDefault();
    this.navService.sideNavs.forEach((item) => {
      item.opened = item.url === nav.url ? !nav.opened : false;
    });
  }

  collapseNav() {
    this.navService.sideNavs.forEach((item) => {
      item.opened = false;
    });
  }

  handleNavItemClick(e: Event, nav: any) {
    if (this.router.url === nav.url) {
      if (!this.navService.getSideNav()) this.collapseNav();
      this.navService.setSideNav(true);
    }

    if (this.navService.getSideNav() && nav.children && nav.children.length > 0) {
      this.toggleNav(e, nav);
      return;
    }

    this.navService.setSideNav(false);
    this.router.navigate([nav.url]);
  }

  handleSubNavNavItemClick(e: Event, subNav: any) {
    //* work for query params
    if (subNav.isQueryParams) {
      this.router.navigate([subNav.url], {
        queryParams: subNav.querParams,
      });
    } else {
      this.router.navigate([subNav.url]);
    }
  }
}
